import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export function getHubInfo() {
  return http.get(`hubs/v1/hubs/${PortalIdParser.get()}`);
}